import { Reducer } from 'redux';
import { AuthActionEnum, AuthActions, IAuthState } from '.';

export const initialState: IAuthState = {
  loading: false,
  login: false,
  errorMessage: '',
};

export const authReducer: Reducer<IAuthState, AuthActions> = (
  state = initialState,
  action: AuthActions
) => {
  switch (action.type) {
    case AuthActionEnum.AuthenticateUser:
      return { ...state, loading: true };
    case AuthActionEnum.AuthenticateUserSuccess:
      return {
        ...state,
        loading: false,
        login: action.state?.login ? action?.state?.login : false,
      };
    case AuthActionEnum.AuthenticateUserFailure:
      return {
        ...state,
        loading: false,
        login: action.state?.login ? action?.state?.login : false,
        errorMessage: action.state?.errorMessage
          ? action.state.errorMessage
          : '',
      };
    default:
      return state;
  }
};
